<!-- 
INDICADOR DO DASHBOARD

params: {
    name: '',             ==> GRAPH_VENDAS_PEDIDO, DASH_VENDAS_PEDIDO...
    title: '',
    indicator: {
        button: { 
            title: '',
            class: '',    ==> nb-btn-1, nb-btn-2, nb-btn-3
        },
    },
    chart: {
        title: '',
        subtitle: '',
        legend: { position: 'top' }
    },
}

filter: {
    startDate: null,
    endDate: null,
    codusuario: null,
}

-->

<template>
    <div v-if="params.chart && show">
        <GChart :type="params.chart.type" :data="params.values" :options="chartOptions"></GChart>
        <!-- <div style="position: absolute; font-size: 18px; white-space: nowrap; left: 330px; top: 128px;">
            <span style="color: #3b3b3b; display: block; text-align: center; font-size: 40px; height: 47px;">5</span> 
        </div> -->
    </div>
</template>

<script>
// google-charts
// https://developers.google.com/chart/interactive/docs/gallery/piechart#donut

import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue, formatMesExtenso } from '../shared/utils'
import { GChart } from 'vue-google-charts/legacy'

export default {
    props: {
      params: { type: Object },
    },

    components: {
        GChart
    },

    data () {
        return {
            values: [],
            otherOptions: {
                chart: {
                    // title: '',
                    // subtitle: '',
                    // legend: { position: 'right' },
                },
                isStacked: false, 
                colors: ['#7DCEA0', '#d98880', '#5288ac', '#f8eb71', '#CD6155', '#bb8fce', '#e59866', '#cd6155'],
                height: 300,
                is3D: true,
                showRowNumber: true, 
                backgroundColor: {strokeWidth: 0 },
                pointSize: 3,
                // chartArea: { top:50, width:'90%', height:'65%' },
                chartArea: { top:50, width:'80%' },
                legend: { position: 'top', alignment: 'center', textStyle: {color: 'gray', fontSize: 12} },
                tooltip: { textStyle: { color: '#222', fontSize: 12 } },
                hAxis: {
                    textStyle: { color: 'gray', fontSize: 12 },
                    // title: 'Time of Day',
                    // format: 'h:mm a',
                    // viewWindow: {
                    //     min: [3, 5, 0],
                    //     max: [5, 10, 0]
                    // }
                },
                vAxis: {
                    textStyle: { color: 'gray', fontSize: 12 },
                    // title: 'Time of Day',
                    // format: '',
                },
            },

            pieOptions: {
                chart: {
                    // title: '',
                    // subtitle: '',
                    // legend: { position: 'right' },
                },
                isStacked: true, 
                colors: ['#cd6155', '#a569bd', '#5dade2', '#52be80', '#f5b041', '#dc7633'],
                is3D: false,
                pieHole: 0.7,
                height: 300,
                // width: 400,
                sliceVisibilityThreshold: 0,
                showRowNumber: true, 
                crosshair: { trigger: 'both' },
                backgroundColor: {strokeWidth: 0 },
                chartArea:{ top: 50, width:'90%', height:'60%' },
                pieSliceText: 'value',
                pieSliceTextStyle: { color: '#222', fontSize: 12 },
                legend: { position: 'bottom', alignment: 'center', textStyle: {color: '#222', fontSize: 11} },
                tooltip: { textStyle: { color: '#222', fontSize: 12 } }
            },            

            help: 'teste de help de indicador do dashboard',
            labelMes: '',
            title: '',
            show: true,
        }
    },

    computed: {
        chartOptions: function () {
            if (this.params.chart.type === 'PieChart') {
                return this.pieOptions
            } else {
                if (this.params.colors)
                  this.otherOptions.colors = this.params.colors
                return this.otherOptions
            }
        },
    },

    watch: {
        filter: {
            handler() {
                if (this.filter) {
                    this.loadData()
                }
            },
            deep: true
        },
    },

    methods: {

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    created () {
        console.log(this.params)
    }

}

</script>

<style scoped>


</style>





// WEBPACK FOOTER //
// src/consultas/chart.vue